import React, { useEffect } from 'react'
import UPI from '../Images/UPI.svg'
import kotakImg from '../Images/Arrow-white.svg'
import Ruppee from '../Images/Rupee.svg'
import { ErrorMessage, Formik, useFormik } from 'formik'
import * as Yup from "yup";
import axios from 'axios';
import { useState } from 'react'
import HDFC from "../Images/hdfc.svg"
import Kotak from '../Images/kotak.svg'
import Lang from '../Images/lang.svg'
import Paytm from "../Images/paytm.svg"
import Digio from '../Images/digio.svg'
import iconAdd from '../Images/ico-add.svg'
import Gpay from '../Images/gpay.svg'
import Phonepe from '../Images/PhonePe.svg'
import cholaLogo from '../Images/Cholamandalam_logo.svg'
import { useLocation, useNavigate } from 'react-router-dom'
import Loader from './Loader'
import { useSnackbar } from 'notistack'
import { useDispatch, useSelector } from 'react-redux'
import { setLoggedIn, setMessage, setOtpTriggered } from './MandateSlice'
import PaymentCheck from './PaymentCheck'
import iciciImg from '../Images/icici.svg'
import amazonImg from '../Images/amazon-pay-circle-round-logo-19775.png'
import credImg from '../Images/62b2bd2a71ce714ca167ebfb_cred.png'
import bhimImg from '../Images/bharat-interface-for-money-bhim-logo-vector.svg'
import qrrCode from '../Images/qrr.jpg'


function UPI_Mandate() {
    const navigate = useNavigate()
    const { mandateID, mobileMode, partner } = useSelector((state) => state.mandateInfo);
    const { mandateData } = useSelector((state) => state.mandateInfo);
    const dispatch = useDispatch()
    const { enqueueSnackbar } = useSnackbar();
    const [showErr, setShowErr] = useState(false)
    // const source_Sys = sessionStorage.getItem('vertical')
    // const amount = sessionStorage.getItem('amount')
    // const leadId = sessionStorage.getItem('leadId')
    const [disable, setDisable] = useState(false)
    const { state } = useLocation();
    const { mandateIdType } = useSelector((state) => state.mandateInfo);
    const [opt, setOpt] = useState([])
    const [loader, setLoader] = useState(false)
    const [paymentCheck, setPaymentCheck] = useState(false)
    // const mandate = sessionStorage.getItem('mandate')
    const initialValue = { upi: mandateData?.upi ? mandateData?.upi : '', amount: mandateData?.Collection_Amount ? mandateData?.Collection_Amount : '', mail: mandateData?.mail ? mandateData?.mail : '', mandate: mandateIdType, name: mandateData?.Name ? mandateData?.Name : '', mobileNo: mandateData?.Phone ? mandateData?.Phone : '', email: mandateData?.Email ? mandateData?.Email : '', accountNo: mandateData?.Account_number ? mandateData?.Account_number : '' }
    const [response, setResponse] = useState()
    const [url, setUrl] = useState()
    const [qrCode, setQrCode] = useState()
    const schema = Yup.object().shape({
        upi: Yup.string().matches(
            "^[a-zA-Z0-9._-]+$",
            'Invalid UPI ID'
        ).required('UPI ID Required'),
        mail: Yup.string().test("Please select an option", "Please select an option", (val) => {
            if (val === undefined || val === '') {
                return false;
            }
            return true;
        }),
        // name: Yup.string().when('mandate', {
        //     is: 'upi-mandate',
        //     then: Yup.string()
        //     .required('Name is Required')
        //     .matches(/^[a-zA-Z0-9\s,'-/.&]*$/, "Enter a valid Name")
        //     .test("Name Length", "The minimum and maximum limit of name is 3 and 40", (val) => {
        //         if (val === undefined || val === '') {
        //             return false;
        //         }
        //         if ((val.length < 3) || (val.length > 40)) {
        //             return false;
        //         }
        //         return true;
        //       }),
        //     }),
        accountNo: Yup.string()
            .when('mandate', {
                is: 'hdfc-upi-mandate',
                then: () => Yup.number()
                    .required("This field is required")
                // .matches(/^[0-9]{9,18}$/, "Please enter valid Account Number")
            }),
        name: Yup.string()
            .when('mandate', {
                is: (val) => val === 'upi-mandate' || val === 'hdfc-upi-mandate',
                then: () => Yup.string().typeError('Invalid name').nullable().transform((value, originalValue) =>
                    originalValue.trim() === '' ? null : value
                )
                    .required('name is required')
                    .matches(/([A-z][\s\.]|[A-z])+/, "Enter a valid name")
                    .test("Name Length", "Must be minimun 3 characters", (val) => {
                        if (val === undefined || val === '') {
                            return false;
                        }
                        if (val.length < 3) {
                            return false;
                        }
                        return true;
                    })
            }),
        mobileNo: Yup.string()
            .when('mandate', {
                is: 'upi-mandate',
                then: () => Yup.string()
                    .required('Mobile number is required')
                    .test("Mobile number length", "Must be exactly 10 numbers", (val) => {
                        if (!val) return false;
                        if (val.toString().length < 10) {
                            return false;
                        }
                        return true;
                    })
            }),
        email: Yup.string()
            .when('mandate', {
                is: 'upi-mandate',
                then: () => Yup.string().matches(
                    /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,4}$/,
                    'Invalid email address'
                ).required('Email ID Required')
            }),
        // amount: Yup.string()
        //     .required('Amount is required')
        //     .test('Amount Length', 'The minimum and maximum limit of amount is 1', (val) => {
        //         if (val === undefined || val === '') {
        //             return false;
        //         }
        //         if (val.length < 1) {
        //             return false;
        //         }
        //         return true;
        //     }),
    })
    useEffect(() => {
        axios({ url: process.env.REACT_APP_BANK_UPI_API, method: 'GET', headers: { "Access-Control-Allow-Origin": "*", Authorization: process.env.REACT_APP_API_KEY } }).then((response) => { setOpt(response?.data) }).catch((e) => {
            setLoader(false)
            setShowErr(e?.message)
        });
    }, [])
    const formik = useFormik({
        initialValues: initialValue,
        validationSchema: schema,
        onSubmit: async (values) => { updateMandate(values) }
    })
    const updateMandate = (values) => {
        dispatch(setMessage(true))
        setLoader(true)
        // let response = '<html>\n<head>\n<title>Show Payment Page</title>\n</head>\n<body>\n<center>\n<h1>Please do not refresh this page...</h1>\n</center>\n<form method=\"post\" action=\"https://securegw-stage.paytm.in/theia/api/v1/upiPollPage?mid=Cholam55387597375923&orderId=5Q2a4yp6bvfwSMmQ64rP\" name=\"paytm\">\n<table border=\"1\">\n<tbody>\n<input type=\"hidden\" name=\"mid\" value=\"Cholam55387597375923\">\n<input type=\"hidden\" name=\"orderId\" value=\"5Q2a4yp6bvfwSMmQ64rP\">\n<input type=\"hidden\" name=\"txnToken\" value=\"d1cdc116052643df87d2429611ca973d1697172113394\">\n</tbody>\n</table>\n<script type=\"text/javascript\"> document.paytm.submit(); </script>\n</form>\n</body>\n</html>'
        // let responsePop = response.split('<body>').pop();
        // let responseSplit = responsePop.split('</body>').shift();
        // var div = document.getElementById('showResponse');
        // div.innerHTML += responseSplit;
        // let conversion = new DOMParser().parseFromString(responseSplit, "text/xml")
        // setResponse(conversion)
        // console.log(response)
        let data = mandateIdType === 'upi-mandate' && {
            "Loan_Amount": mandateData?.Loan_Amount,
            "Collection_Amount": mandateData?.Collection_Amount,
            "lead_id": mandateData?.lead_id,
            "upi_id": values.upi + values.mail,
            "upi_name": values.upi,
            "Mandate_type": mandateIdType,
            "Phone": values.mobileNo.toString(),
            "Email": values.email,
            "Name": values.name,
            "callback_url": mandateData?.callback_url,
            "Frequency": mandateData?.Frequency,
            "Source_Sys": mandateData?.Source_Sys,
            "redirect_url": mandateData?.redirect_url,
            "unique_id": mandateID ? mandateID : mandateData?.unique_id,
            "First_Collection_Date": mandateData?.First_Collection_Date,
            "Last_Collection_Date": mandateData?.Last_Collection_Date
        } || (mandateIdType === 'hdfc-upi-mandate' || mandateIdType === 'icici-upi-mandate') &&
            {
                "Loan_Amount": mandateData?.Loan_Amount,
                "Collection_Amount": mandateData?.Collection_Amount,
                "lead_id": mandateData?.lead_id,
                "upi_id": values.upi + values.mail,
                "Mandate_type": mandateIdType,
                "Name": values.name,
                "Frequency": mandateData?.Frequency,
                "Account_number": values.accountNo.toString(),
                "Source_Sys": mandateData?.Source_Sys,
                "redirect_url": mandateData?.redirect_url,
                "callback_url": mandateData?.callback_url,
                "unique_id": mandateID ? mandateID : mandateData?.unique_id,
                "First_Collection_Date": mandateData?.First_Collection_Date,
                "Last_Collection_Date": mandateData?.Last_Collection_Date,
            }
            || {
            "Loan_Amount": mandateData?.Loan_Amount,
            "Collection_Amount": mandateData?.Collection_Amount,
            "lead_id": mandateData?.lead_id,
            "upi_id": values.upi + values.mail,
            "Mandate_type": mandateIdType,
            "Frequency": mandateData?.Frequency,
            "Source_Sys": mandateData?.Source_Sys,
            "redirect_url": mandateData?.redirect_url,
            "callback_url": mandateData?.callback_url,
            "First_Collection_Date": mandateData?.First_Collection_Date,
            "Last_Collection_Date": mandateData?.Last_Collection_Date,
            "unique_id": mandateID ? mandateID : mandateData?.unique_id,
        };
        // let data = {
        //     "Amount": "1",
        //     "lead_id": "chodefelgra1234",
        //     "upi_id": "7777777777",
        //     "Mandate_type": "paytm-upi-mandate", 
        //     "Source_Sys": "Sams"
        // }
        let config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: process.env.REACT_APP_UPI_API,
            headers: {
                'Authorization': 'Bearer ' + process.env.REACT_APP_API_KEY
            },
            data: data
        };

        const redirectUrl = (orderId, token) => {
            let url = `https://ustgapig.chola.murugappa.com/cselmandateapi/1.0.0/paytm/pagehost?orderID=${orderId}&token=${token}`
            window.location.assign(url)
        }
        if (mandateData?.lead_id && mandateData?.Source_Sys && mandateIdType) {
            axios.request(config)
                .then((response) => {
                    setLoader(false)
                    if (response?.data?.Status === "Success" && (mandateIdType === 'upi-mandate')) {
                        setDisable(true)
                        window.location.assign(response?.data?.redirect_url)
                    }
                    else if (response?.data?.Status === "Success" && (mandateIdType === 'icici-upi-mandate' || mandateIdType === 'hdfc-upi-mandate')) {
                        setPaymentCheck(true)
                        sessionStorage.setItem("paymentcheck", "enable")
                    }
                    else if (mandateIdType === 'paytm-upi-mandate') {
                        setDisable(true)
                        response?.data?.URL ? window.location.assign(response?.data?.URL) :
                            // enqueueSnackbar("Something went wrong", {
                            //     variant: "error",
                            //     preventDuplicate: true,
                            //     autoHideDuration: 3000,
                            // });
                            setShowErr("Something went wrong")
                    }
                    // else if (response?.data?.body?.bankForm?.upiDirectForm?.content?.orderId && response?.data?.body?.bankForm?.upiDirectForm?.content?.token) {
                    //     setDisable(true)
                    //     redirectUrl(response?.data?.body?.bankForm?.upiDirectForm?.content?.orderId, response?.data?.body?.bankForm?.upiDirectForm?.content?.token)
                    // }
                    else {
                        // enqueueSnackbar(response?.data?.Message, {
                        //     variant: "error",
                        //     preventDuplicate: true,
                        //     autoHideDuration: 3000,
                        // });
                        setShowErr(response?.data?.Message)
                    }

                    // let url = `https://ustgapig.chola.murugappa.com/cselmandateapi/1.0.0/paytm/pagehost?orderID=${response?.data?.body?.bankForm?.upiDirectForm?.content?.orderId}&token=${response?.data?.body?.bankForm?.upiDirectForm?.content?.token}`
                    // window.location.assign(url)
                })
                .catch((error) => {
                    setLoader(false)
                    setShowErr(error?.message)
                });
        }
        else {
            // enqueueSnackbar("Missing data", {
            //     variant: "error",
            //     preventDuplicate: true,
            //     autoHideDuration: 3000,
            // });
            setShowErr("Data Missing, Please try again later")
        }

    }
    const openUpiApp = (values) => {
        setLoader(true)
        let data = {
            "Loan_Amount": mandateData?.Loan_Amount,
            "Collection_Amount": mandateData?.Collection_Amount,
            "lead_id": mandateData?.lead_id,
            "Mandate_type": mandateIdType === 'hdfc-upi-mandate' && "hdfc-upi-intent" || mandateIdType === 'icici-upi-mandate' && 'icici-upi-intent',
            "Frequency": mandateData?.Frequency,
            "Source_Sys": mandateData?.Source_Sys,
            "redirect_url": mandateData?.redirect_url,
            "callback_url": mandateData?.callback_url,
            "First_Collection_Date": mandateData?.First_Collection_Date,
            "Last_Collection_Date": mandateData?.Last_Collection_Date,
            "unique_id": mandateID ? mandateID : mandateData?.unique_id,
            "deviceType": mobileMode?.toLowerCase(),
            "request_type": values === 'QR' ? 'QR' : 'INTENT',
            "psp_type": values
        };
        let config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: process.env.REACT_APP_UPI_API,
            headers: {
                'Authorization': 'Bearer ' + process.env.REACT_APP_API_KEY
            },
            data: data
        };
        axios.request(config)
            .then((response) => {
                setLoader(false);
                if (response?.data?.URL) {
                    if (values === 'QR') {
                        setQrCode(response?.data?.URL)
                    }
                    else {
                        setPaymentCheck(true)
                        window.location.assign(response?.data?.URL)
                    }
                }
                else {
                    setShowErr("Something went wrong")
                }
            })
            .catch((e) => {
                setLoader(false)
                setShowErr(e?.message)
            });
    }
    const logout = () => {
        dispatch(setOtpTriggered(false))
        dispatch(setLoggedIn(false))
        navigate('/login')
    }
    const handleSubmit = event => {
        event.preventDefault();
        formik.handleSubmit()
    };

    useEffect(() => {
        if (Object.keys(mandateData).length === 0) {
            navigate('/payment')
        }
    }, [mandateData])

    console.log(qrCode, "qrCode")

    return (
        <>
            {loader && <Loader />}
            {/* {response &&
                <>
                    <iframe src={response} width="100%" style={{ height: "100vh" }} />
                </>} */}
            {(opt && !paymentCheck && !qrCode) && <form onSubmit={handleSubmit}>

                {/* <div class="Banner-sm">
                    <div class="container Payment-way-page">
                        <div class="row">
                            <div class="col-12 ps-4 pe-4">
                                <div class="Bcrumb">
                                    <a className="nav-link" onClick={() => { window.history.go(-1); return false; }}>
                                        <img class="face" src={kotakImg} />
                                    </a>
                                    <span class="Mandate-text"><img className="me-2 face" src={mandateIdType === 'digio-e-mandate' && Digio || mandateIdType === 'paytm-upi-mandate' && Paytm || mandateIdType === 'hdfc-upi-mandate' && HDFC || mandateIdType === 'upi-mandate' && Kotak} /> UPI Mandate </span>
                                </div>
                            </div>
                        </div>
                        <div className="row UPI-PAY">
                            <div class="col-12 ps-4 pe-4 mt-4 mb-4">
                                {(mobileMode && window.matchMedia("only screen and (max-width:767px)").matches && mandateIdType === 'paytm-upi-mandate') && <div className="col-12 mt-2">
                                    <p class="fw-semibold">Pay using UPI App</p>
                                    <div className='d-flex'>
                                        <div class="card p-3 me-2" onClick={()=>{openUpiApp('gpay')}}>
                                                <img src={Gpay} alt="" height={"42px"} width={"42px"}/>
                                        </div>
                                        <div class="card p-3 me-2" onClick={()=>{openUpiApp('phonepe')}}>
                                                <img src={Phonepe} alt="" height={"42px"} width={"42px"}/>
                                        </div>
                                        <div class="card p-3 me-2 d-grid" onClick={()=>{openUpiApp('others')}}>
                                                <span style={{marginTop:"8px"}}>Others</span>
                                        </div>
                                    </div>
                                </div>}
                                <div className="col-12 mt-2">
                                <p class="fw-semibold">Pay using UPI ID</p>
                                    <div className='has-icon'>
                                        <div className="UPI-form mb-3">
                                            <div className={"upibox " + ((formik.errors.upi && formik.touched.upi) ? "is-invalid" : "")} >
                                                <input type="text" Placeholder="Enter UPI ID" onChange={formik.handleChange} value={formik.values.upi} name="upi" className="datatext" id="datatext" />
                                                <select className="contentselect" id="contentselect" name="mail" onChange={formik.handleChange} value={formik.values.mail}>
                                                    <option value="">@Choose...</option>
                                                    {opt.map((opt) => (<option value={opt}>{opt}</option>))}
                                                </select>
                                                <img src={UPI} /></div>
                                            <div className="invalid-feedback">
                                                {formik.errors.upi && formik.touched.upi
                                                    ? formik.errors.upi : ''}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 mt-2">
                                    <div class="UPI-form">
                                        <div class="has-icon form-floating mb-3">
                                            <input type="number" min={1} class={"form-control " + ((formik.errors.amount && formik.touched.amount) ? "is-invalid" : "")} name="amount" onChange={formik.handleChange} value={formik.values.amount} id="floatingInput" placeholder="name@example" readOnly={mandateData?.Collection_Amount} />
                                            <label for="floatingInput">Amount</label>
                                            <div className="invalid-feedback">
                                                {formik.errors.amount && formik.touched.amount
                                                    ? formik.errors.amount
                                                    : ''}
                                            </div>
                                            <img src={Ruppee} /> </div>
                                    </div>
                                </div>
                                {mandateIdType === 'hdfc-upi-mandate' &&
                                    <>
                                        <div className="col-12 mt-2">
                                            <div className="UPI-form">
                                                <div className="form-floating mb-3">
                                                    <input type="number" className={"form-control " + ((formik.errors.accountNo && formik.touched.accountNo) ? "is-invalid" : "")} id="floatingInput1" name="accountNo" onChange={formik.handleChange} value={formik.values.accountNo} onBlur={formik.handleBlur} readOnly={mandateData?.Account_number} placeholder=" Enter Account No" />
                                                    <label for="floatingInput">Account No</label>
                                                    <div className="invalid-feedback">
                                                        {formik.errors.accountNo && formik.touched.accountNo
                                                            ? formik.errors.accountNo
                                                            : ''}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-12 mt-2">
                                            <div className="UPI-form">
                                                <div className="form-floating mb-3">
                                                    <input type="text" className={"form-control " + ((formik.errors.name && formik.touched.name) ? "is-invalid" : "")} id="floatingInput1" name="name" onChange={formik.handleChange} value={formik.values.name} readOnly={mandateData?.Name} placeholder="Enter Name" />
                                                    <label for="floatingInput">Name</label>
                                                    <div className="invalid-feedback">
                                                        {formik.errors.name && formik.touched.name
                                                            ? formik.errors.name
                                                            : ''}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                }
                                {mandateIdType === 'upi-mandate' &&
                                    <>
                                        <div className="col-12 mt-2">
                                            <div className="UPI-form">
                                                <div className="form-floating mb-3">
                                                    <input type="number" className={"form-control " + ((formik.errors.mobileNo && formik.touched.mobileNo) ? "is-invalid" : "")} id="floatingInput3" name="mobileNo" onChange={formik.handleChange} value={formik.values.mobileNo} readOnly={mandateData?.Phone} placeholder="Enter Phone No" />
                                                    <label for="floatingInput">Phone No.</label>
                                                    <div className="invalid-feedback">
                                                        {formik.errors.mobileNo && formik.touched.mobileNo
                                                            ? formik.errors.mobileNo
                                                            : ''}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-12 mt-2">
                                            <div className="UPI-form">
                                                <div className="form-floating mb-3">
                                                    <input type="email" className={"form-control " + ((formik.errors.email && formik.touched.email) ? "is-invalid" : "")} id="floatingInput4" name="email" readOnly={mandateData?.Email} onChange={formik.handleChange} value={formik.values.email} placeholder="Email" />
                                                    <label for="floatingInput">Email</label>
                                                    <div className="invalid-feedback">
                                                        {formik.errors.email && formik.touched.email
                                                            ? formik.errors.email
                                                            : ''}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-12 mt-2">
                                            <div className="UPI-form">
                                                <div className="form-floating mb-3">
                                                    <input type="text" className={"form-control " + ((formik.errors.name && formik.touched.name) ? "is-invalid" : "")} id="floatingInput1" name="name" onChange={formik.handleChange} value={formik.values.name} readOnly={mandateData?.Name} placeholder="Enter Name" />
                                                    <label for="floatingInput">Name</label>
                                                    <div className="invalid-feedback">
                                                        {formik.errors.name && formik.touched.name
                                                            ? formik.errors.name
                                                            : ''}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </>}
                                {showErr && <div class="alert alert-danger alert-dismissible fade show" role="alert">
                                    {showErr}
                                    <button type="button" class="btn-close" data-bs-dismiss="alert" onClick={() => { setShowErr(false) }} aria-label="Close">x</button>
                                </div>}
                                <div className="d-grid gap-2 mb-3">
                                    <button className="btn btn-primary Proceed_btn" disabled={disable} type="submit button">Register</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> */}
                {/*2048 is the width for ipad pro 12.9 inch*/}
                <div class="container in-spacer">
                    <div class="row">
                        {(mobileMode && window.matchMedia("only screen and (max-width:748px)").matches && (mandateIdType === 'icici-upi-mandate')) && <>
                            <div class="col-12 mb-4">
                                <h6 class="mb-3">UPI Mandate</h6>
                                {mandateIdType !== 'hdfc-upi-mandate' && <div class="upiSel">
                                    <div className='col-12'>
                                        <div className='row'>
                                            <div class="customRadio">
                                                <input type="radio" name="role" id="paytm" value="paytm" onClick={() => { openUpiApp('paytmmp') }} />
                                                <label for="paytm"><img class="face img-fluid" src={Paytm} alt="" />
                                                </label>
                                            </div>
                                            <div class="customRadio">
                                                <input type="radio" name="role" id="gpay" value="gpay" onClick={() => { openUpiApp('gpay') }} />
                                                <label for="gpay">
                                                    <img class="face img-fluid" src={Gpay} alt="" />
                                                </label>
                                            </div>
                                            <div class="customRadio">
                                                <input type="radio" name="role" id="ppe" value="ppe" onClick={() => { openUpiApp('phonepe') }} />
                                                <label for="ppe">
                                                    <img class="face img-fluid" src={Phonepe} alt="" />
                                                </label>
                                            </div>
                                        </div>
                                        {mandateIdType === 'icici-upi-mandate' &&
                                            <div className='col-12 row'>
                                                <div class="customRadio">
                                                    <input type="radio" name="role" id="icici" value="icici" onClick={() => { openUpiApp('dricici') }} />
                                                    <label for="icici">
                                                        <img class="face img-fluid" src={iciciImg} alt="" />
                                                    </label>
                                                </div>
                                                <div class="customRadio">
                                                    <input type="radio" name="role" id="amazon" value="amazon" onClick={() => { openUpiApp('amazonpay') }} />
                                                    <label for="amazon">
                                                        <img class="face img-fluid" src={amazonImg} alt="" />
                                                    </label>
                                                </div>
                                                <div class="customRadio">
                                                    <input type="radio" name="role" id="cred" value="cred" onClick={() => { openUpiApp('credpay') }} />
                                                    <label for="cred">
                                                        <img class="face img-fluid" src={credImg} alt="" />
                                                    </label>
                                                </div>
                                                <div class="customRadio">
                                                    <input type="radio" name="role" id="bhim" value="bhim" onClick={() => { openUpiApp('bhim') }} />
                                                    <label for="bhim">
                                                        <img class="face img-fluid" src={bhimImg} alt="" />
                                                    </label>
                                                </div>
                                            </div>}
                                    </div>
                                </div>}
                                {mandateIdType !== 'icici-upi-mandate' && <button class="btn add_btn" type='button' onClick={() => { (openUpiApp('others')) }}>
                                    <img src={iconAdd} /> UPI Apps
                                </button>}
                            </div>
                            <div class="col-12 mb-3">
                                <div class="or">
                                    <span class="txt">OR</span>
                                </div>
                            </div>
                        </>}
                        {mandateData?.Source_Sys !== "CD-LOS" && 
                        <>
                        <h6 class="mb-3">Pay with <b style={{ color: "red" }}>QR Code</b></h6>
                        <div class="upiSel">
                            <div className='col-12'>
                                <div className='row'>
                                    <div class="customRadio">
                                        <input type="radio" name="role" id="qr" value="qr" onClick={() => { openUpiApp('QR') }} />
                                        <label for="qr">
                                            <img class="face img-fluid" src={qrrCode} alt="" />
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 mb-3">
                            <div class="or">
                                <span class="txt">OR</span>
                            </div>
                        </div>
                        </>}
                        <h6 class="mb-3">Pay by Entering <b style={{ color: "red" }}>UPI ID linked to Account number</b> given during Loan Journey</h6>
                        <div class="col-12">
                            <div class="upibox mb-3">
                                <input type="text" placeholder="Enter UPI ID" onChange={formik.handleChange} value={formik.values.upi} name="upi" class="datatext " className={"w-50 datatext " + ((formik.errors.upi && formik.touched.upi) ? "is-invalid" : "")} id="datatext" />
                                <select class="contentselect" id="contentselect" name="mail" onChange={formik.handleChange} value={formik.values.mail}>
                                    <option>@choose</option>
                                    {opt.map((opt) => (<option value={opt}>{opt}</option>))}
                                </select>
                                <img src={UPI} />
                                <div className="invalid-feedback">
                                    {formik.errors.upi && formik.touched.upi
                                        ? formik.errors.upi : ''}
                                </div>
                            </div>
                        </div>
                        <div class="col-12">
                            <div class="UPI-form">
                                <div class="has-icon form-floating mb-3">
                                    <input type="number" min={1} class={"form-control " + ((formik.errors.amount && formik.touched.amount) ? "is-invalid" : "")} name="amount" onChange={formik.handleChange} value={formik.values.amount} id="floatingInput" placeholder="name@example" readOnly={mandateData?.Collection_Amount} />
                                    <label for="floatingInput">Amount</label>
                                    <div className="invalid-feedback">
                                        {formik.errors.amount && formik.touched.amount
                                            ? formik.errors.amount
                                            : ''}
                                    </div>
                                    <img src={Ruppee} /> </div>
                            </div>
                        </div>
                        {(mandateIdType === 'hdfc-upi-mandate' || mandateIdType === 'icici-upi-mandate') &&
                            <>
                                <div className="col-12 mt-2">
                                    <div className="UPI-form">
                                        <div className="form-floating mb-3">
                                            <input type="number" className={"form-control " + ((formik.errors.accountNo && formik.touched.accountNo) ? "is-invalid" : "")} id="floatingInput1" name="accountNo" onChange={formik.handleChange} value={formik.values.accountNo} onBlur={formik.handleBlur} readOnly={mandateData?.Account_number} placeholder=" Enter Account No" />
                                            <label for="floatingInput">Account No</label>
                                            <div className="invalid-feedback">
                                                {formik.errors.accountNo && formik.touched.accountNo
                                                    ? formik.errors.accountNo
                                                    : ''}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {(mandateIdType !== 'icici-upi-mandate') && <div className="col-12 mt-2">
                                    <div className="UPI-form">
                                        <div className="form-floating mb-3">
                                            <input type="text" className={"form-control " + ((formik.errors.name && formik.touched.name) ? "is-invalid" : "")} id="floatingInput1" name="name" onChange={formik.handleChange} value={formik.values.name} readOnly={mandateData?.Name} placeholder="Enter Name" />
                                            <label for="floatingInput">Name</label>
                                            <div className="invalid-feedback">
                                                {formik.errors.name && formik.touched.name
                                                    ? formik.errors.name
                                                    : ''}
                                            </div>
                                        </div>
                                    </div>
                                </div>}
                            </>
                        }
                        {(mandateIdType === 'upi-mandate') &&
                            <>
                                <div className="col-lg-5 col-sm-6 col-12">
                                    <div className="UPI-form">
                                        <div className="form-floating mb-3">
                                            <input type="number" className={"form-control " + ((formik.errors.mobileNo && formik.touched.mobileNo) ? "is-invalid" : "")} id="floatingInput3" name="mobileNo" onChange={formik.handleChange} value={formik.values.mobileNo} readOnly={mandateData?.Phone} placeholder="Enter Phone No" />
                                            <label for="floatingInput">Phone No.</label>
                                            <div className="invalid-feedback">
                                                {formik.errors.mobileNo && formik.touched.mobileNo
                                                    ? formik.errors.mobileNo
                                                    : ''}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-5 col-sm-6 col-12">
                                    <div className="UPI-form">
                                        <div className="form-floating mb-3">
                                            <input type="email" className={"form-control " + ((formik.errors.email && formik.touched.email) ? "is-invalid" : "")} id="floatingInput4" name="email" readOnly={mandateData?.Email} onChange={formik.handleChange} value={formik.values.email} placeholder="Email" />
                                            <label for="floatingInput">Email</label>
                                            <div className="invalid-feedback">
                                                {formik.errors.email && formik.touched.email
                                                    ? formik.errors.email
                                                    : ''}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12 mt-2">
                                    <div className="UPI-form">
                                        <div className="form-floating mb-3">
                                            <input type="text" className={"form-control " + ((formik.errors.name && formik.touched.name) ? "is-invalid" : "")} id="floatingInput1" name="name" onChange={formik.handleChange} value={formik.values.name} readOnly={mandateData?.Name} placeholder="Enter Name" />
                                            <label for="floatingInput">Name</label>
                                            <div className="invalid-feedback">
                                                {formik.errors.name && formik.touched.name
                                                    ? formik.errors.name
                                                    : ''}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </>}
                        {showErr &&
                            <div class="gap-2">
                                <div class="alert alert-danger alert-dismissible fade show" role="alert">
                                    <p class="mb-1">{showErr}</p>
                                    <button type="button" class="btn-close" data-bs-dismiss="alert" onClick={() => { setShowErr(false) }} aria-label="Close">&#215;</button>
                                </div>
                            </div>
                        }
                        <div className="d-grid gap-2 mb-3">
                            <button className="btn btn-primary Proceed_btn" disabled={disable} type="submit button">Register</button>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <nav class="navbar MenuTop fixed-top navbar-expand-lg navstyles">
                                <div class="container">
                                    <a class="navbar-brand-sm" href="#">
                                        <img src={cholaLogo} alt="Chola Logo" />
                                    </a>
                                    <ul class="nav-list">
                                        <li class="nav-item">
                                            {/* <a class="nav-link" href="Language.html">
                                                <img src={Lang} />
                                            </a> */}
                                        </li>
                                        {partner === 'chola-web' && <li>
                                            <a href="#" onClick={logout}>Logout</a>
                                        </li>}
                                    </ul>
                                </div>
                            </nav>
                        </div>
                    </div>
                </div>
            </form >
            }
            {
                (paymentCheck || qrCode) &&
                <PaymentCheck qrCode={qrCode} />
            }
        </>
    )
}

export default UPI_Mandate